import { render, staticRenderFns } from "./ProjectAccessListing.vue?vue&type=template&id=2fd0b320&scoped=true&"
import script from "./ProjectAccessListing.vue?vue&type=script&lang=js&"
export * from "./ProjectAccessListing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAccessListing.vue?vue&type=style&index=0&id=2fd0b320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0b320",
  null
  
)

export default component.exports